<template>
  <div id="printWrapper" class="container-fluid">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card border-0">
            <div class="card-body">
              <h2 class="card-title text-center brand-text-primary font-weight-light py-2">{{  title  }}</h2>
              <p class="card-text text-secondary">{{ subTitle }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <mortgage-calculator :colors="colors" :producturl="productUrl" :show-sidebar="showSidebar" :sidebar-color="sidebarColor" :sidebar-text="sidebarText"/>
    <footer-component v-if="showFooter" :text="footerText" />
  </div>
</template>

<script>

import FooterComponent from "@/components/FooterComponent.vue";
import MortgageCalculator from "@/components/MortgageCalculator.vue";
export default {
  name: 'CustomComponent',
  components: {
    MortgageCalculator,
    FooterComponent
  },
  data () {
    return {
      title: 'Calculate Your Monthly Payment',
      subTitle: 'Our calculator tool helps your better understand your budget and home eligibility by giving you an estimated monthly payment based on purchase price, current loan rates, and loan terms.',
      showFooter: true,
      showSidebar: true,
      sidebarText: 'Our professionals are ready to assist you with a personalized estimate, tailored to your specific wants, needs and situation when you\'re ready. Let us help you finance with confidence.',
      footerText: '* The figures shown are estimates and are subject to change based on a more thorough review of your needs, choices, and credit history. The payments shown do not include other expenses you will incur as a homeowner; such as taxes and insurance. For an even more accurate quote, contact a loan officer.',
      productUrl: '/find-a-loan-officer/',
      colors: '#002248,#29b6f6,#b3e5fc,#01579b,#667A91',
      sidebarColor: '#a5afcf'
    }
  },
  mounted(){
    let q = this.$router.currentRoute.query
    this.showFooter = (q.showFooter === 'true')
    this.showSidebar = (q.showSidebar === 'true')
    this.colors = q.colors
  },
  methods:{
  }
}
</script>

<style>

</style>
